import { render } from "./uploadfile.vue?vue&type=template&id=28402eab&scoped=true"
import script from "./uploadfile.vue?vue&type=script&lang=js"
export * from "./uploadfile.vue?vue&type=script&lang=js"

import "./uploadfile.vue?vue&type=style&index=0&id=28402eab&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28402eab"]])

export default __exports__